import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [IonicModule, TranslateModule],
})
export class HeaderComponent {
    @Input()
    public title?: string;
    @Input()
    public icon?: string;
    @Input()
    public iconColor?: 'primary' | 'light' | 'dark' = 'primary';
    @Input() displayIcon = true;
    @Input() background = false;
    @Input() loader = false;
    @Input()
    public disabled = false;

    @Output() action: EventEmitter<void> = new EventEmitter();

    triggerAction() {
        this.action.emit();
    }
}
